export default __webpack_public_path__ + "static/media/ic-arrowBlue.4712249e.svg";